import { useDisclosure } from "@/hooks";
import { useUpdatePayment } from "@/hooks/query-hooks/usePayments";
import { useNotificationStore } from "@/states/zustand/notification";
import { Button, Form, Modal } from "antd";
import { FormValues, PaymentForm } from "./PaymentForm";
import { createPaymentRequestSchema } from "@/constants/zod-schemas";

export function EditPaymentModal({
    payment
}: {
    payment: Payment
}) {

    const [opened, { toggle }] = useDisclosure(false);
    const [form] = Form.useForm();

    const { mutate, isMutating } = useUpdatePayment();
    const onSubmit = (data: FormValues) => {
        const { image } = data;
        const jsonData = createPaymentRequestSchema.parse(data);
        const formData = new FormData();
        formData.append("data", new Blob([JSON.stringify(jsonData)], { type: "application/json" }));
        formData.append("imageUrl", image?.file as unknown as File);

        const payload = {
            id: payment.id,
            data: formData
        }

        mutate(payload, {
            onSuccess: (data) => {
                toggle();
                form.setFieldsValue(data);
                useNotificationStore.getState().setNotification({
                    type: "success",
                    message: "Payment method updated successfully!"
                })
            }
        })
    }

    return (
        <>
            <Button
                type="link"
                onClick={toggle}
                size="small"
                disabled={payment.paymentType === "Cash"}
            >
                Edit
            </Button>
            <Modal
                open={opened}
                title="Payment အချက်အလက် ပြင်ဆင်ရန်"
                onCancel={toggle}
                okText="အတည်ပြုမည်"
                cancelText="ပယ်ဖျက်မည်"
                okButtonProps={{
                    form: `edit-payment-form-${payment.id}`,
                    htmlType: "submit",
                    type: "primary",
                    size: "large",
                    className: "bg-primary-gradient",
                    shape: "round",
                    loading: isMutating,
                }}
                cancelButtonProps={{
                    type: "text",
                    size: "large",
                    style: {
                        background: "transparent",
                    },
                    disabled: isMutating,
                }}
                centered
                maskClosable={!isMutating}
            >
                <PaymentForm
                    form={form}
                    onSubmit={onSubmit}
                    name={`edit-payment-form-${payment.id}`}
                    initialValues={{
                        ...payment
                    }}
                    openedModal={opened}
                />
            </Modal>
        </>
    )
}
